import React from "react";
import Header from "src/Component/content-component/Header";
import ParaData from "src/Component/content-component/ParaData";
import ContentContainer from "src/Component/grid-component/ContentContainer";
import ImageContainer from "src/Component/grid-component/ImageContainer";
import MainContainer from "src/Component/grid-component/MainContainer";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
const ImmigrationImg1 = imageBaseUrl +"International-Relation/IndiaPage/studentMobality.jpg";
const MobilityProgramme = () => {
  return (
    <>
      <MainContainer
        com2={
          <ContentContainer
            Header={
              <Header content={"Student Mobility Program"} color="#00999E" />
            }
            Content={
              <ParaData
                color={"#525560"}
                fontSize={"16px"}
                content={
                  <>
                    At <b>Taksheela Institute of Education</b>, we facilitate{" "}
                    <b>Student Exchange Programmes</b> between{" "}
                    <b>Indian and foreign universities/institutions</b> in the
                    fields of <b>Technical Education, Research, and Training</b>
                    . Our services help{" "}
                    <b>Higher Educational Institutions (HEIs)</b> seamlessly
                    integrate collaborative academic programs as per{" "}
                    <b>AICTE norms</b> and <b>global educational standards</b>.
                  </>
                }
              />
            }
          />
        }
        com1={<ImageContainer img={ImmigrationImg1} />}
      />
    </>
  );
};

export default MobilityProgramme;
